import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

export default function AdminLogin() {
  const { admin, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (admin) navigate("/admin/dashboard");
  }, [admin, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin/dashboard");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-cream-2 grain px-5" data-testid="admin-login">
      <div className="relative w-full max-w-md rounded-sm bg-cream p-10">
        <div className="mb-8 text-center">
          <span className="mx-auto mb-3 flex h-16 w-16 items-center justify-center rounded-full bg-cream-2 ring-1 ring-gold/50 overflow-hidden">
            <img src="https://static.prod-images.emergentagent.com/jobs/abf143d2-3bb8-4a2a-af45-7e99c0ea4245/images/6805d3b0d317e33dca9e9925a0dfa6800fd2617eb6c4e4e8f51370977e4702f6.jpeg" alt="Cured & Clear emblem" className="h-full w-full object-cover scale-110" />
          </span>
          <p className="font-serif text-2xl text-moss">Cured <span className="text-gold">&</span> Clear</p>
          <p className="mt-1 font-mono text-xs uppercase tracking-[0.24em] text-gold">Admin Portal</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="font-mono text-xs uppercase tracking-wider text-muted">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full rounded-sm border border-[#E4DDD0] bg-cream-2 px-4 py-3 text-sm focus:border-gold focus:outline-none"
              data-testid="admin-email"
              required
            />
          </div>
          <div>
            <label className="font-mono text-xs uppercase tracking-wider text-muted">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full rounded-sm border border-[#E4DDD0] bg-cream-2 px-4 py-3 text-sm focus:border-gold focus:outline-none"
              data-testid="admin-password"
              required
            />
          </div>
          {error && <p className="text-sm text-terracotta" data-testid="admin-error">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            className="btn-gold flex w-full items-center justify-center gap-2 rounded-sm py-3.5 text-sm font-semibold uppercase tracking-wider disabled:opacity-60"
            data-testid="admin-login-submit"
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />} Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
